import React from 'react';
import PropTypes from 'prop-types';
import { OPERATOR_NAMES } from './constants';
import { ConditionText } from './styled';

export const VersionCondition = ({ operator, value }) => (
  <ConditionText>
    version must {OPERATOR_NAMES[operator]} {value}
  </ConditionText>
);

VersionCondition.propTypes = {
  value: PropTypes.string.isRequired,
  operator: PropTypes.string.isRequired,
};
